module.exports = __webpack_public_path__ + "static/media/aulogo_dk_var2_hvid.d0fc01d7.png";